module.exports = __webpack_public_path__ + "static/media/sliderimg1.47a913c4.png";